// extracted by mini-css-extract-plugin
module.exports = {"focus-width":"1.5px","toggleItem":"ToggleGroup_toggleItem__e4dww","toggleItemOn":"ToggleGroup_toggleItemOn__1ytkk","toggleGroupRoot":"ToggleGroup_toggleGroupRoot__9pvGa"};